import { UserStore } from "@/services/stores/types";

export const selectUserStore = ({ user, setUser }: UserStore) => ({
  user,
  setUser,
});

export const selectUserData = ({ user }: UserStore) => ({ user });
